export class QueryBuilder {
  query

  constructor() {
    this.query = {}
  }

  orderBy(sort) {
    this.query.sort = sort

    return this
  }

  where(key, value) {
    this.query['filter[' + key + ']'] = value

    return this
  }

  include(...args) {
    this.query.include = args

    return this
  }

  append(...args) {
    this.query.append = args

    return this
  }

  page(page) {
    this.query.page = page

    return this
  }

  limit(limit) {
    this.query.limit = limit

    return this
  }

  get() {
    return this.query
  }

  toString() {
    return new URLSearchParams(this.query).toString()
  }
}
